<template>
    <icon-default
        class="cross"
        :size="'mini'"
        :color="focusOut ? 'light-purple' : 'purple'"
        :class="[direction]">
      <arrow/>
    </icon-default>
</template>

<script>
import Arrow from "@/assets/icons/arrows/arrow.svg?inline";
import IconDefault from "@/components/shared/icons/IconDefault";
export default {
  name: "IconArrow",
  components: {Arrow, IconDefault},
  props: {
    focusOut: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String
    }
  },
}
</script>

<style scoped lang="scss">
.icon-container {
  transition: all .3s ease;
  &.right {
    transform: rotate(270deg);
  }
  &.left {
    transform: rotate(90deg);
  }
  &.top {
    transform: rotate(180deg);
  }
  &.active-direction {
    transform: rotate(180deg);
  }
}
</style>